// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ApiResult, get, post } from "./api_client";
import { AlertStatus, AlertSeverity } from "../models";
import { Alert, IAlert, AlertEvent, IAlertEvent, ResolveBody, IResolveBody } from "../models";
/* eslint-enable @typescript-eslint/no-unused-vars */

export async function list(organizationId?: string, facilityId?: string, deviceId?: string, status?: AlertStatus, minSeverity?: AlertSeverity, take?: number): ApiResult<Alert[]> {
		const queryParams = [organizationId !== undefined ? `organizationId=${organizationId}` : undefined,
			facilityId !== undefined ? `facilityId=${facilityId}` : undefined,
			deviceId !== undefined ? `deviceId=${deviceId}` : undefined,
			status !== undefined ? `status=${status}` : undefined,
			minSeverity !== undefined ? `minSeverity=${minSeverity}` : undefined,
			take !== undefined ? `take=${take}` : undefined]
		var query = queryParams.filter((v) => (v !== undefined)).join('&');
		if (query && query.length)
			query = '?' + query;

	return get<IAlert[]>(`/api/alert/${query}`).then(result => result === undefined ? undefined : result.map(o => new Alert(o)));
}

export async function getAlert(alertId?: string): ApiResult<Alert> {
	return get<IAlert>(`/api/alert/${ alertId }`).then(result => result === undefined ? undefined :  new Alert(result));
}

export async function getEvents(alertId?: string): ApiResult<AlertEvent[]> {
	return get<IAlertEvent[]>(`/api/alert/${ alertId }/events`).then(result => result === undefined ? undefined : result.map(o => new AlertEvent(o)));
}

export async function acknowledge(alertId?: string): ApiResult<Alert> {
	return post<IAlert>(`/api/alert/${ alertId }/acknowledge`).then(result => result === undefined ? undefined :  new Alert(result));
}

export async function resolve(alertId?: string, body?: ResolveBody): ApiResult<Alert> {
	return post<IAlert>(`/api/alert/${ alertId }/resolve`, body).then(result => result === undefined ? undefined :  new Alert(result));
}
